<template>
  <v-dialog v-model="isOpen" max-width="290">
    <v-card>
      <v-card-title class="headline">{{ opts.headline }}</v-card-title>

      <v-card-text>
        {{ opts.text }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn :color="opts.agreeColor" flat="flat" @click="agreeClicked()">
          {{ opts.agree }}
        </v-btn>

        <v-btn
          :color="opts.disagreeColor"
          flat="flat"
          @click="disagreeClicked()"
        >
          {{ opts.disagree }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'Dialog',
  props: [
    'preset',
    'headline',
    'text',
    'agree',
    'disagree',
    'dialog',
    'payload',
    'onAgree',
    'onDisagree',
    'agreeColor',
    'disagreeColor'
  ],
  data() {
    return {
      isOpen: false,
      opts: {
        headline: 'Headline',
        text: 'Text',
        agree: 'Agree',
        disagree: 'Disagree',
        payload: {},
        onAgree: '',
        onDisagree: '',
        agreeColor: 'green darken-1',
        disagreeColor: 'green darken-1'
      },
      eventPayload: {}
    }
  },
  mounted() {
    if (this.preset) {
      this.applyPreset(this.preset)
    }
    for (const i in this.opts) {
      this.opts[i] = this[i] || this.opts[i]
    }
    this.setEventPayload(this.opts.payload)
  },

  methods: {
    // Set payload for events
    setEventPayload(payload) {
      if (payload !== undefined) {
        this.eventPayload = payload
      }
    },
    // Open dialog
    open(payload) {
      this.isOpen = true
      this.setEventPayload(payload)
    },
    // Close dialog
    close(payload) {
      this.isOpen = false
      this.setEventPayload(payload)
      this.onAgreeEvent()
    },
    // Agree btn clicked
    agreeClicked() {
      this.isOpen = false
      this.onAgreeEvent()
    },
    // Disagree gu
    disagreeClicked() {
      this.isOpen = false
      this.onDisagreeEvent()
    },

    // Emit event on agree clicked
    onAgreeEvent() {
      if (this.opts.onAgree) {
        this.$emit(this.opts.onAgree, this.eventPayload)
      }
    },

    // Emit event on disagree clicked
    onDisagreeEvent() {
      if (this.opts.onDisagree) {
        this.$emit(this.opts.onDisagree, this.eventPayload)
      }
    },

    // Apply dialog preset : for delete or any other dialogs
    applyPreset(preset) {
      const presets = {
        delete: {
          headline: this.$vuetify.t('$vuetify.dialogs.delete.headline'),
          text: this.$vuetify.t('$vuetify.dialogs.delete.text'),
          agree: this.$vuetify.t('$vuetify.dialogs.delete.agree'),
          disagree: this.$vuetify.t('$vuetify.dialogs.delete.disagree'),
          onAgree: 'deleted',
          onDisagree: 'canceled',
          agreeColor: 'red',
          disagreeColor: 'primary'
        }
      }
      if (presets[preset] !== undefined) {
        for (const i in presets[preset]) {
          this.opts[i] = presets[preset][i]
        }
      }
    }
  },
  computed: {}
}
</script>

<style scoped></style>
